<div class="full-flex-height justify-content-center align-items-center flex-row innerAppButton appButtons">
   <a
      *ngIf="canViewRegionalManagerSummary"
      href="./growth-toolkit/regional-manager-summary"
      class="box mr-5">
      <div class="card">
         <div class="card-body">
            <h1 class="card-title ico text-center appButton-red">
               <i class="fas fa-list-check"></i>
            </h1>
            <h4 class="text-center">Regional Manager Summary</h4>
         </div>
      </div>
   </a>

   <a
      *ngIf="canViewHospitalManagerDashboard"
      href="./growth-toolkit/hospital-manager-dashboard"
      class="box mr-5">
      <div class="card">
         <div class="card-body">
            <h1 class="card-title ico text-center appButton-red">
               <i class="fas fa-dashboard"></i>
            </h1>
            <h4 class="text-center">Hospital Manager Dashboard</h4>
         </div>
      </div>
   </a>

   <a
      *ngIf="canViewDirectorSummary"
      href="./growth-toolkit/director-summary"
      class="box mr-5">
      <div class="card">
         <div class="card-body">
            <h1 class="card-title ico text-center appButton-red">
               <i class="fa fa-user-cog"></i>
            </h1>
            <h4 class="text-center">Director View</h4>
         </div>
      </div>
   </a>

   <div *ngIf="!canViewRegionalManagerSummary && !canViewHospitalManagerDashboard && !canViewDirectorSummary">
      <h2>If you cannot see any buttons, it is because you don't have access to the proper Application Roles.</h2>
   </div>
</div>
